import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Break Place</h4>
          <p>Rulota cu mancare de calitate, preparate proaspete zilnic.</p>
        </div>

        <div className="footer-section">
          <h4>Meniu Rapid</h4>
          <ul>
            <li><a href="#meniu">Meniu</a></li>
            <li><a href="#qr">Cod QR</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <ul>
            <li><a href="tel:+40712345678">Telefon</a></li>
            <li><a href="mailto:contact@breakplace.ro">Email</a></li>
            <li>Program disponibil</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {currentYear} Break Place. Toate drepturile rezervate.
        </p>
        <p className="footer-note">Design profesional pentru business-ul tau.</p>
      </div>
    </footer>
  );
}

export default Footer;
